module.exports = __webpack_public_path__ + "media/promo/velle/images/white_subs-14b57b7ae5936e8914719e62241e24bc.png";